import ListIcon from '@material-ui/icons/List';
import JobList from './JobList';
import JobShow from './JobShow';

const pages = {
    list: JobList,
    show: JobShow,
    icon: ListIcon,
};

export default pages;